module.exports = __webpack_public_path__ + "static/img/tower.ad49242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tower.jpg
// module id = 169
// module chunks = 1